// extracted by mini-css-extract-plugin
module.exports = {"title":"ItemActionPanel_title__3xKil","wrapper":"ItemActionPanel_wrapper__1Wsxv","bc":"ItemActionPanel_bc__3rbA-"};